import { useId, useState } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { showErrorAlert } from '@/shared/lib/errors'
import { Button } from '@/shared/ui/Button'

import { useCreateComment } from '../model/mutations'

const CommentAvatar = ({ name }) => (
  <div
    aria-hidden
    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-200 text-2xs font-bold text-gray-700"
  >
    {name?.[0]?.toUpperCase() || '?'}
  </div>
)

export const CommentSection = ({ eventSlug, postId, comments = [], isLoading }) => {
  const [content, setContent] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const { createComment } = useCreateComment(eventSlug, postId)
  const fieldId = useId()

  const handleSubmit = async e => {
    e.preventDefault()
    if (!content.trim()) return
    setSubmitting(true)
    try {
      await createComment(content.trim())
      setContent('')
    } catch (err) {
      showErrorAlert(err)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="mt-3 border-t border-border pt-3">
      {isLoading ? (
        <p className="py-2 text-sm text-gray-700">Carregando comentários...</p>
      ) : (
        <div className="mb-3 space-y-2">
          {comments.map(comment => (
            <div key={comment.id} className="flex gap-2">
              <CommentAvatar name={comment.user?.name} />
              <p className="m-0 flex-1 text-base text-gray-900">
                <span className="font-semibold">{comment.user?.name} </span>
                <span className="text-gray-700">{comment.content}</span>
              </p>
            </div>
          ))}
          {comments.length === 0 && (
            <p className="m-0 text-sm text-gray-700">Nenhum comentário ainda.</p>
          )}
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex items-end gap-2">
        <div className="min-w-0 flex-1">
          <Label htmlFor={fieldId} className="sr-only">
            Escreva um comentário
          </Label>
          <Input
            id={fieldId}
            value={content}
            onChange={e => setContent(e.target.value)}
            placeholder="Escreva um comentário..."
            disabled={submitting}
            autoComplete="off"
          />
        </div>
        <Button
          type="submit"
          size="sm"
          variant="primary"
          showTrailingIcon={false}
          loading={submitting}
          disabled={submitting || !content.trim()}
        >
          Enviar
        </Button>
      </form>
    </div>
  )
}
